import React, { useState } from "react";
import { Formik, Form, Field, useField } from "formik";
import * as Yup from "yup";
import emailjs from "emailjs-com";
import TelephoneEmailLink from "./TelephoneEmailLink";
import "./ContactForm.css";
import backgroundFooter from "../assets/wtm-hero-3.jpg";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button, Container, Headline } from "./ui";

const MyTextarea = ({ label, ...props }) => {
  const [field, meta] = useField(props);
  return (
    <>
      <label
        htmlFor={props.id || props.name}
        className="text-base font-medium mb-0 block"
      >
        {label}
      </label>
      <div style={{ position: "relative" }}>
        <textarea className="textarea-input" {...field} {...props} />
        {meta.touched && meta.error ? (
          <div className="contact-error text-sm text-red-400">{meta.error}</div>
        ) : null}
      </div>
    </>
  );
};

const MyTextInput = ({ label, ...props }) => {
  const [field, meta] = useField(props);
  return (
    <>
      <label
        htmlFor={props.id || props.name}
        className="text-base font-medium  mb-0 block"
      >
        {label}
      </label>
      <div style={{ position: "relative" }}>
        <input className="text-input" {...field} {...props} />
        {meta.touched && meta.error ? (
          <div className="contact-error text-sm text-red-400">{meta.error}</div>
        ) : null}
      </div>
    </>
  );
};

const MyCheckbox = ({ children, ...props }) => {
  const [field, meta] = useField({ ...props, type: "checkbox" });
  return (
    <div className="checkbox-wrapper">
      <label className="checkbox-input mb-0">
        <input {...field} {...props} type="checkbox" />
        {children}
      </label>
      {meta.touched && meta.error ? (
        <div className="contact-error-checkbox text-sm text-red-400">
          {meta.error}
        </div>
      ) : null}
    </div>
  );
};

export const ContactForm = ({
  headline = "Weitere Anliegen?",
  intro = "Kontaktieren Sie uns über das ausführliche Formular.",
  formHeadline = "Wir freuen uns von Ihnen zu hören",
  formIntro = "",
  hideMessage = false,
}) => {
  const [isFormOpen, setIsFormOpen] = useState(true);

  return (
    <div
      id="contact-form"
      style={{
        backgroundColor: "var(--color-primary)",
      }}
    >
      <Container maxWidth="none" className="py-10">
        <div className="form-wrapper rounded-xl shadow-lg ">
          <Headline
            variant="splitscreen"
            color="primary"
            className="text-left my-6 max-w-4xl mx-auto"
          >
            {formHeadline}
          </Headline>
          <p className="text-lg text-gray-700 leading-relaxed mb-8 max-w-4xl mx-auto">
            {formIntro}
          </p>

          <div className="max-w-4xl mx-auto">
            <Formik
              initialValues={{
                name: "",
                email: "",
                phone: "",
                message: "",
                consent: false, // Added initial value for the checkbox
              }}
              validationSchema={Yup.object({
                name: Yup.string()
                  .max(25, "Must be 25 characters or less")
                  .required("Pflichtfeld"),
                email: Yup.string()
                  .email("Invalid email address")
                  .required("Pflichtfeld"),
                phone: Yup.string().required("Pflichtfeld"),
                message: hideMessage
                  ? Yup.string()
                  : Yup.string().required("Pflichtfeld"),
                consent: Yup.boolean()
                  .oneOf([true], "Sie müssen zustimmen") // Validation for the checkbox
                  .required("Pflichtfeld"),
              })}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                // toast.success(
                //   "Vielen Dank für Ihre Nachricht! Wir melden uns unverzüglich bei Ihnen."
                // );
                emailjs
                  .send(
                    "service_t0w7lhk",
                    "template_nbeag76",
                    {
                      from_name: values.name,
                      email: values.email,
                      message: values.message || "Keine Nachricht angegeben",
                      phone: values.phone,
                    },
                    "7yrBfJRP1uVs_QHMZ"
                  )
                  .then(
                    (result) => {
                      toast.success(
                        "Vielen Dank für Ihre Nachricht! Wir melden uns unverzüglich bei Ihnen."
                      );
                      resetForm();
                    },
                    (error) => {
                      toast.error(
                        "Ein Fehler ist aufgetreten, bitte kontaktieren Sie uns direkt per Telefon oder Email."
                      );
                    }
                  )
                  .finally(() => {
                    setSubmitting(false);
                  });
              }}
            >
              {({ isSubmitting, isValid }) => (
                <Form>
                  <MyTextInput
                    label="Vollständiger Name"
                    name="name"
                    type="text"
                    placeholder="Andre Mustermann"
                  />

                  <MyTextInput
                    label="Ihre Email Addresse"
                    name="email"
                    type="email"
                    placeholder="andre@mustermann.com"
                  />
                  <MyTextInput
                    label="Telefonnummer für Rückfragen"
                    name="phone"
                    type="text"
                    placeholder="0179 3434 888"
                  />

                  {!hideMessage && (
                    <MyTextarea
                      label="Ihre Nachricht"
                      name="message"
                      rows="4"
                      placeholder="Schreiben Sie Ihre Nachricht hier"
                    />
                  )}

                  <MyCheckbox name="consent"></MyCheckbox>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Ich stimme der Verarbeitung meiner Daten zur Bearbeitung der
                    Anfrage zu.
                  </p>

                  <Button
                    type="submit"
                    variant="primaryInverse"
                    disabled={isSubmitting || !isValid}
                    className="mt-6"
                    id="contact-form-submit"
                  >
                    {isSubmitting ? (
                      <FontAwesomeIcon icon={faSpinner} spin />
                    ) : (
                      "Abschicken"
                    )}
                  </Button>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </Container>
      <ToastContainer />
    </div>
  );
};
